export default __webpack_public_path__ + "static/media/004-homepage-3.78c6e4fc.svg";